export default __webpack_public_path__ + "static/media/close-outline.86596f2d.svg";